import { sceconfig } from 'sce-core';

export const environment = {
  production: false,
  logger: 'console',
  baseUrlUI: sceconfig.wms.baseUrlUI,
  // wmsApiBaseUrl: 'https://ofsce-dev.lflogistics.net/scecommon/',  // localhost envrionment
  //  wmsApiBaseUrl: 'https://ofsce-sit.lflogistics.net/scecommon/', // sit envrionment
  // wmsApiBaseUrl: 'https://ofsce-uat.lflogistics.net/scecommon/', // uat envrionment

  //  notificationApiBaseUrl : 'https://ofscetms-uat.lflogistics.net/api' // uat envrionment
  // notificationApiBaseUrl : 'https://ofscetms-sit.lflogistics.net/api' // sit envrionment
  // notificationApiBaseUrl: 'https://ofscetms-dev.lflogistics.net/api' // localhost envrionment

  wmsApiBaseUrl: 'https://stage-wms.ocf.fulfillment.maersk.com/scecommon/', // wrb uat envrionment
  notificationApiBaseUrl: 'https://stage-tms.ocf.fulfillment.maersk.com/api', // wrb uat envrionment

  RUM_APP_ID: 'TMSWeb-UAT',
  RUM_API_KEY:
    'uONFiBfJvKGUnE1aVP/zwbeW2lWceUlUKT2k2myZ2hQue/6gAKiRTOJ5CmMpkQ==',
};
